<template>
  <el-dialog :visible="visible" @open="open" @close="close" fullscreen :close-on-click-modal="false" append-to-body class="editor">
    <el-row v-if="tmpl" slot="title">
      <!-- <el-tag v-if="tmpl.verId == entity.id" type="success" size="mini" effect="plain">最新版</el-tag> -->
      <el-tag v-if="entity.ifEditing" type="warning" size="mini" effect="plain">编辑中版本</el-tag>
      {{ tmpl.scope }}文书模板预览： <b>{{ tmpl.name }}</b>
      <!-- <span v-if="entity.ver"> {{ `${entity.ver}.0` }}</span> -->
      <small>（{{ tmpl.deptCode | dictText("Dept") }}-{{ tmpl.category | dictText("MrCategory") }}-{{ tmpl.type | dictText("MrType") }}）</small>
    </el-row>
    <el-container class="f-h">
      <el-aside width="17rem" style="padding: 0.5rem" v-show="showAside">
        <el-collapse v-model="actCollapseItem" accordion @change="collapseChange">
          <el-collapse-item title="模板基本信息" name="0">
            <b slot="title"><i class="el-icon-s-grid" /> 模板基本信息 </b>
            <el-descriptions v-if="tmpl" title="" :column="1" size="mini">
              <el-descriptions-item label="名称">{{ tmpl.name }}</el-descriptions-item>
              <el-descriptions-item label="编码">{{ tmpl.code }}</el-descriptions-item>
              <el-descriptions-item label="领域">{{ tmpl.scope }}</el-descriptions-item>
              <el-descriptions-item label="分类">{{ tmpl.category | dictText("MrCategory") }}</el-descriptions-item>
              <el-descriptions-item label="类型">{{ tmpl.type | dictText("MrType") }}</el-descriptions-item>
              <el-descriptions-item label="科室">{{ tmpl.deptCode | dictText("Dept") }}</el-descriptions-item>
              <el-descriptions-item label="性别">{{ tmpl.gender }}</el-descriptions-item>
            </el-descriptions>
          </el-collapse-item>
          <el-collapse-item v-if="!!tmpl.vers && !!tmpl.vers.length" title="版本" name="2">
            <b slot="title"><i class="el-icon-s-flag" /> 版本 </b>
            <el-row v-for="ver in tmpl.vers" :key="ver.id">
              <i v-if="ver.auditState == '通过'" class="el-icon-circle-check right-pad success" title="生效"></i>
              <i v-else class="el-icon-warning-outline right-pad danger" title="草稿"></i>
              <el-link :type="ver.id == currentId ? 'primary' :  ''" @click="changeVer(ver)" :style="ver.id == currentId ? 'font-size: large' : ''" :underline="false">
                {{ ver.ver }}.0
                <small class="left-pad"> {{ ver.auditorName }} {{ ver.auditDate | fmtDate }}</small>
              </el-link>
            </el-row>
          </el-collapse-item>
          <el-collapse-item title="输出结构" name="struct">
            <b slot="title"><i class="el-icon-s-order" /> 输出结构 </b>
            <el-tree :data="docStructTree" default-expand-all highlight-current :expand-on-click-node="false" @node-click="nodeClick">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span>{{ node.label }}</span>
                <el-button v-if="data.isRoot" type="text" icon="el-icon-refresh" circle size="small" @click="refreshStruct"></el-button>
              </span>
            </el-tree>
          </el-collapse-item>
          <el-collapse-item v-if="entity.updateLogs" title="修改记录" name="4">
            <b slot="title"><i class="el-icon-s-open" /> 修改记录 </b>
            <el-timeline>
              <el-timeline-item placement="top" v-for="(log, index) in JSON.parse(entity.updateLogs)" :key="index" :timestamp="log.mrDate">
                <small>{{ log.modifyName }}</small>
              </el-timeline-item>
            </el-timeline>
          </el-collapse-item>
          <el-collapse-item v-if="entity.auditLogs" title="审批记录" name="5">
            <b slot="title"><i class="el-icon-s-check" /> 审批记录 </b>
            <el-timeline>
              <el-timeline-item placement="top" v-for="(log, index) in JSON.parse(entity.auditLogs)" :key="index" :type="log.auditResult == '未通过' ? 'danger' : 'success'" :timestamp="log.auditDate">
                <small>{{ log.auditName }}： {{ log.auditResult }}</small>
                <p v-if="log.reason">{{ log.reason }}</p>
              </el-timeline-item>
            </el-timeline>
          </el-collapse-item>
        </el-collapse>
      </el-aside>
      <el-main ref="main">
        <el-row ref="viewer" class="f-h"> </el-row>
      </el-main>
    </el-container>
    <span slot="footer" class="dialog-footer" style="height: 1px">
      <el-button-group class="pull-left left-pad">
        <el-button type="primary" :icon="showAside ? 'el-icon-reading' : 'el-icon-notebook-1'" @click="switchSideShow" title="布局调整"></el-button>
        <!-- <el-button type="primary" :icon="showTrace ? 'el-icon-no-smoking' : 'el-icon-smoking'" @click="showTrace = !showTrace" title="修订痕迹显示/隐藏"></el-button> -->
        <el-dropdown split-button type="primary" class="left-pad" @click="print()" @command="download">
          <i class="el-icon-printer" />
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-document" command="docx">word文档</el-dropdown-item>
            <el-dropdown-item icon="el-icon-document" command="pdf">pdf文档</el-dropdown-item>
            <el-dropdown-item icon="el-icon-document" command="html">html文档</el-dropdown-item>
            <el-dropdown-item icon="el-icon-document" command="bin">bin文档</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-button-group>
      <el-button type="info" @click="close">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import editorUtils from "@/common/editorUtils";
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      visible: Boolean,
      tmpl: Object,
    },
    data() {
      return {
        entity: {},
        actCollapseItem: "1",
        showAside: false,
        showTrace: false,
        docStruct: {},
        utils: editorUtils,
        currentId: null,
      };
    },
    computed: {
      ...mapGetters(["Enum", "dict", "dictEnum", "user"]),
      docStructTree() {
        return [
          {
            isRoot: true,
            label: "文档",
            children: this.genTree(this.docStruct),
          },
        ];
      },
    },
    methods: {
      async open() {
        let _this = this;
        await _this.$nextTick();
        let oRet = this.utils.createDomEditor(this.$editor, this.$refs.viewer);
        if (oRet.id) {
          console.log(oRet);
        }
        this.initEditorEvent();
        _this.entity = await this.$api.TmplVer.view(_this.tmpl.id);
        if (_this.entity) {
          _this.tmpl = await this.$api.Tmpl.get(_this.entity.mainId);
        }
        _this.currentId = _this.entity.id;
        if (_this.entity.content) {
          oRet = _this.$editor.OpenFile(_this.entity.content, 2, 2);
          if (oRet.id) {
            console.log(oRet);
          }
        } else {
          oRet = _this.$editor.NewFile();
          if (oRet.id) {
            console.log(oRet);
          }
        }
      },
      initEditorEvent() {
        let _this = this;
        _this.$editor.SetToolBarsVisible("All", false);
        _this.$editor.SetLeftPanelVisible(false);
        _this.$editor.SetRPropWindowVisible(false);
        // bin文件加载完毕
        this.$editor.NsoFileOpenCompleted = () => {
          console.log("编辑器已打开文件");
          _this.resize();
          _this.$editor.SetViewProportion(3);
          _this.$editor.BrowseTemplet({ CanEdit: false });
          let oRet = _this.$editor.InitEvents();
          oRet = _this.$editor.SetEditMode(0);
        };
      },
      close() {
        this.utils.removeDomEditor(this.$editor, this.$refs.viewer);
        this.$emit("update:visible", false);
      },
      refreshProps(actName, type) {
        if (!actName) {
          this.eles.actProps = [];
          this.eles.actName = null;
          return;
        }
        if (this.eles.actName == actName) {
          return;
        }
        this.eles.actName = actName;
        let oRet;
        if (!type) {
          oRet = this.$editor.GetNewControlProperty(actName, ["type"]);
          type = oRet.props.type;
        }

        if (type && type != "UnKnown") {
          if (type == this.Enum.MrElementType.表格) {
            oRet = this.$editor.GetTableProperty(actName, editorUtils.getPropCodes(type));
          } else if (type == this.Enum.MrElementType.数据组) {
            oRet = this.$editor.GetSectionProperty(actName, editorUtils.getPropCodes(type));
          } else if (type == this.Enum.MrElementType.区域) {
            oRet = this.$editor.GetRegionProperty(actName, editorUtils.getPropCodes(type));
          } else {
            oRet = this.$editor.GetNewControlProperty(actName, editorUtils.getPropCodes(type));
          }
          this.eles.actProps = editorUtils.getValidProps(type, oRet.props, this.eles.actName).filter((p) => !p.hide);
          // console.log(oRet);
        } else {
          this.eles.actProps = [];
        }
      },
      collapseChange(name) {
        if (name == "struct") {
          this.refreshStruct();
        }
      },
      refreshStruct() {
        // let res = this.$editor.GetStructsXmlInfo(1, true)
        // let doc = this.$x2js.xml2js(res.structsXmlInfo).Root.DocObjContent
        let res = this.$editor.GetStructsXmlInfoByParament(1, true, true, "AllProperty", "AllProperty", "dataName");
        let doc = this.$x2js.xml2js(res.structsXml).Root.DocObjContent;
        this.docStruct = {};
        this.genStruct(doc, this.docStruct);
      },
      genTree(obj) {
        return Object.keys(obj).map((k) => {
          let ele = obj[k];
          let nod = {
            label: k,
          };
          if (typeof ele != "object") {
            nod.label += `：${ele}`;
          }
          if (Array.isArray(ele)) {
            nod.isArray = true;
            if (ele.length && typeof ele[0] === "object") {
              nod.children = this.genTree(ele[0]);
            }
          } else if (ele != null && typeof ele === "object") {
            nod.children = this.genTree(ele);
          }
          return nod;
        });
      },
      genStruct(obj, target) {
        if (Array.isArray(obj)) {
          obj.forEach((o) => {
            this.genStruct(o, target);
          });
          return;
        }
        Object.keys(obj).forEach((k) => {
          let ele = obj[k];

          if (k == "Section" || k == "Region") {
            if (Array.isArray(ele)) {
              ele.forEach((e) => {
                target[e._dataName || e._Name] = {};
                this.genStruct(e, target[e._Name]);
              });
            } else {
              target[ele._dataName || ele._Name] = {};
              this.genStruct(ele, target[ele._Name]);
            }
          } else if (k == "NewCtrl") {
            if (Array.isArray(ele)) {
              ele.forEach((e) => {
                target[e._dataName || e._Name] = e.ParaRun.Text;
              });
            } else {
              target[ele._dataName || ele._Name] = ele.ParaRun.Text;
            }
          } else if (typeof ele === "object") {
            this.genStruct(ele, target);
          }
        });
      },
      nodeClick(row) {
        this.$editor.CursorJumpToOneStruct(row.label.split("：")[0], true);
      },
      typeName(code) {
        return editorUtils.getTypeName(code);
      },
      cellStyle(cell) {
        if (cell.columnIndex == 0) {
          return {
            // "background-color": "WhiteSmoke",
            color: "gray",
          };
        }
        return null;
      },
      propChanged(row) {
        let prop = {};
        prop[row.code] = row.value;
        this.$editor.SetNewControlProperty(this.eles.actName, prop);
      },
      checkApi(apiCodes) {
        if (!apiCodes) {
          return;
        }
        if (!(apiCodes instanceof Array)) {
          apiCodes = [apiCodes];
        }
        apiCodes.forEach((code) => {
          if (this.apis.items.findIndex((a) => a.code == code) == -1) {
            let a = this.apis.all.find((a) => a.code == code);
            if (a) {
              this.apis.items.push(a);
            }
          }
        });
      },
      insertMeta(nodeData, node) {
        if (node.childNodes.length > 0) return;

        let data = editorUtils.structTree2Ele(node);

        this.insert(data);
      },
      switchSideShow() {
        this.showAside = !this.showAside;
        this.$nextTick(() => {
          let oRet = this.$editor.GetSize();
          oRet = this.$editor.SetSize(this.$refs.main.$el.clientWidth, this.$refs.main.$el.clientHeight - 4);
        });
      },
      print() {
        this.$editor.Preview();
      },
      download(fileType) {
        let _this = this;
        let ret = this.$editor.SaveFile(fileType, (e) => {
          if (e.id) {
            _this.$message.error("保存时发生错误，下载失败！");
          } else {
            window.open(e.url, "_blank");
          }
        });
        if (fileType == "bin") {
          editorUtils.downloadBin(ret.base64, `${this.$utils.Dict.text(this.tmpl.code, "MrTemplate")}.bin`);
        } else if (fileType == "html") {
          editorUtils.downloadHtml(ret.html, `${this.$utils.Dict.text(this.tmpl.code, "MrTemplate")}.html`);
        }
      },
      async changeVer(ver) {
        if (ver.id == this.currentId) {
          return;
        }
        let _this = this;
        let oRet;
        this.currentId = ver.id;
        this.entity = await this.$api.TmplVer.get(this.currentId);
        if (_this.entity.content) {
          oRet = _this.$editor.OpenFile(_this.entity.content, 2, 2);
          if (oRet.id) {
            console.log(oRet);
          }
        } else {
          oRet = _this.$editor.CloseFile();
          if (oRet.id) {
            console.log(oRet);
          }
        }
      },
      resize() {
        this.$nextTick(() => {
          // 调整编辑器大小，占满剩余区域
          let oRet = this.$editor.GetSize();
          oRet = this.$editor.SetSize(this.$refs.main.$el.clientWidth, this.$refs.main.$el.clientHeight - 4);
        });
      },
    },
  };
</script>
